import TopicLink from './topicLink'

export { TopicLink }
